import React, { useState } from "react";
import { InputAdornment } from "@mui/material";
import RayaField from "./RayaField";

const NumberField = ({ value, onChange, decimals = 0, min, max, ...props }) => {
    const formatWithThousandSeparator = (number) => {
        if (number === null || number === undefined || number === "") return "";
        const [integerPart, decimalPart] = number.split(".");
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (decimals > 0 && decimalPart !== undefined) {
            return `${formattedInteger}.${decimalPart.slice(0, decimals)}`;
        }
        return formattedInteger;
    };

    const unformatNumber = (formattedNumber) => formattedNumber.replace(/,/g, "");

    const handleChange = (event) => {
        const inputValue = event.target.value;
        const rawValue = unformatNumber(inputValue);

        // Allow intermediate states like "1." or ".5"
        if (!/^\d*(\.\d*)?$/.test(rawValue)) {
            return; // Ignore invalid input
        }

        // Enforce min and max constraints only when the value is fully numeric
        let numericValue = parseFloat(rawValue);
        if (!isNaN(numericValue)) {
            if (min !== undefined && numericValue < min) {
                numericValue = min;
            }
            if (max !== undefined && numericValue > max) {
                numericValue = max;
            }
        } else {
            numericValue = rawValue; // Preserve non-numeric intermediate states
        }

        const formattedValue =
            rawValue === "" || rawValue.endsWith(".")
                ? rawValue // Preserve the trailing decimal during typing
                : formatWithThousandSeparator(numericValue.toString());

        onChange && onChange(numericValue); // Pass raw numeric value to parent
        setInputValue(formattedValue); // Display formatted value
    };

    const [inputValue, setInputValue] = useState(
        formatWithThousandSeparator(value?.toString() || "")
    );

    return (
        <RayaField
            {...props}
            value={inputValue}
            onChange={handleChange}
            slotProps={{
                htmlInput: {
                    inputMode: "decimal",
                    pattern: `[0-9]*(\\.[0-9]{0,${decimals}})?`, // Allow decimals based on the `decimals` prop
                },
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            {props.endAdornment}
                        </InputAdornment>
                    ),
                    startAdornment: (
                        <InputAdornment position="start">
                            {props.startAdornment}
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default NumberField;
